/* ==========================================================================
   Fair-Turbo Grundsystem, Verhalten (02.10.2026, LAYOUT-FIXES Phase 2)

   1) Kopf: Seit 04.10.2026 spät bleibt die schwarze Leiste am PC und Tablet stehen;
      am Handy scrollt sie ganz weg, auf der Produktseite am Handy ist sie aus
      (Entscheidung B vom 05.10.2026; CSS, sticky mit negativem top, --ft-topbar-weg).
      Die Kopfzeile bleibt immer stehen (Pascal 02.10. abends). Setzt am <html>:
        --ft-topbar-h      Höhe der schwarzen Leiste
        --ft-kopf-h        klebende Kopfhöhe (Kopfzeile plus stehender Teil der schwarzen Leiste)
        --ft-kopf-sichtbar sichtbare Kopfhöhe jetzt (--ft-kopf-h oder 0)
        .ft-kopf-weg       Kopfzeile gerade ausgeblendet
      Andere klebende Leisten (Filter, Reiter) nutzen --ft-kopf-sichtbar.

   2) Kontakt-Knopf: aufklappen, schließen (Tippen daneben, Esc), beim
      Runterscrollen weg, beim Hochscrollen da. Weg auch, solange die
      Fußzeile oder der Cookie-Hinweis im Bild ist (dort steht Kontakt im
      Klartext bzw. liegen Zustimmungsknöpfe) oder ein Kasten mit
      .ft-dock-frei hinter dem Knopf liegt.

   3) Chip-Leisten (.ft-chipleiste) und Reiter „Sofort lieferbar“ (.ft-fpb-tabs): Klasse is-mehr für den Verlauf rechts,
      der aktive Chip (.is-on) wird beim Laden ins Bild gescrollt.
   4) Werkzeugleiste (.ft-wl-leiste): Klasse is-klebt, solange sie klebt.

   Bewusst ohne requestAnimationFrame und ohne Timer-Warteschleifen: rAF
   steht im Hintergrund-Tab, und das alte Wegblinken der Kreise kam aus
   „bei jedem Scroll weg, nach 700 ms zurück“ (13.08.). Hier entscheidet
   nur die Richtung, mit 8 px Schwelle gegen Zittern.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.documentElement;
  var SCHWELLE = 8;

  /* ── 1) Kopf ─────────────────────────────────────────────────────────── */
  var kopf = document.querySelector('.ft-header');
  var sek = kopf ? (kopf.closest('.shopify-section') || kopf.parentElement) : null;
  var leiste = kopf ? kopf.querySelector('.ft-topbar') : null;
  var kopfWeg = false;

  function offenesMenue() {
    var d = document.getElementById('ft-drawer');
    var s = document.getElementById('ft-search-overlay');
    if (d && !d.hidden) return true;
    if (s && !s.hidden) return true;
    if (kopf && kopf.contains(document.activeElement) && /INPUT|SELECT|TEXTAREA/.test(document.activeElement.tagName)) return true;
    return !!document.querySelector('.ft-header [aria-expanded="true"]');
  }

  function messen() {
    if (!sek) return;
    var tb = leiste ? leiste.offsetHeight : 0;
    root.style.setProperty('--ft-topbar-h', tb + 'px');
    /* 04.10.2026 spät: Wie viel der schwarzen Leiste wegscrollt, legt das CSS fest (--ft-topbar-weg in ft-system.css:
       am PC nichts, am Handy hochkant Zeile 1, am Handy quer alles). Gemessen wird der tatsächliche Versatz des klebenden
       Abschnitts; sichtbar bleibt der Rest der Leiste plus Kopfzeile. Vorher wurde immer die ganze Leiste abgezogen. */
    /* 14.10.2026 nachts (Testshop): Am Handy scrollt dort die Kopfzeile 1 weg (--ft-topbar-weg 52 px), die schwarze Leiste ist
       ausgeblendet (tb 0). Dann zählt der Versatz selbst, sonst klebte die Filterleiste 52 px zu tief (weiße Lücke). */
    /* 16.10.2026 nachts: Seit Runde 14 steht die schmale Leiste auch am Handy (32 px) und scrollt mit Kopfzeile 1 weg
       (--ft-topbar-weg 84 px). Die Begrenzung auf die Leistenhöhe zog nur 32 px ab, die Filterleiste klebte 52 px zu tief
       (Karten schauten darüber durch, Bild k42_kategorie). Der Versatz des klebenden Abschnitts ist selbst die Wahrheit. */
    var weg = Math.max(-(parseFloat(getComputedStyle(sek).top) || 0), 0);
    var h = Math.max(sek.offsetHeight - weg, 0);
    root.style.setProperty('--ft-kopf-h', h + 'px');
    root.style.setProperty('--ft-kopf-sichtbar', (kopfWeg ? 0 : h) + 'px');
  }

  function setzeKopf(weg) {
    if (weg === kopfWeg) return;
    kopfWeg = weg;
    root.classList.toggle('ft-kopf-weg', weg);
    messen();
  }

  /* ── 2) Kontakt-Knopf ────────────────────────────────────────────────── */
  var kontakt = document.querySelector('[data-ft-schnellkontakt]');
  var kKnopf = kontakt ? kontakt.querySelector('.ft-schnellkontakt-knopf') : null;
  var kMenue = kontakt ? kontakt.querySelector('.ft-schnellkontakt-menue') : null;
  /* Fußzeile, Cookie-Hinweis und offenes Filterblatt: weg, sobald sie im Bild sind.
     Kästen mit .ft-dock-frei (Rechtshinweise, Preisrechnung): weg nur, solange sie
     hinter dem Knopf liegen (unterste 84 px). Vorher reichte „irgendwo im Bild“,
     dann blieb der Knopf auf der Startseite fast immer aus (Leiste mit Zusagen oben). */
  var zonenGanz = kontakt ? [].slice.call(document.querySelectorAll('footer, #ft-cookie-banner, #ft-coll-mobilebar.is-sheet-open')) : [];
  var zonenUnten = kontakt ? [].slice.call(document.querySelectorAll('.ft-dock-frei')) : [];
  var KNOPF_BEREICH = 84;
  var kontaktWegScroll = false;
  /* 12.10.2026 (Pascal: zwei getrennte Knöpfe für WhatsApp und Telefon, auch auf Produktseite und im Warenkorb):
     Feste Kaufleisten unten heben die Knöpfe an (--ft-sk-unten), solange die Leiste zu sehen ist. Kaufknöpfe und „Zur Kasse“
     sind Schutzzonen wie .ft-dock-frei: Liegt einer hinter den Knöpfen, sind sie weg. Der Bereich ist so hoch wie die Knöpfe
     plus 24 px, gemessen über der Kaufleiste. */
  var leistenUnten = kontakt ? [].slice.call(document.querySelectorAll('.ft-pdp-stickybar, #ft-cart-mobilebar')) : [];
  var schutzKnoepfe = kontakt ? [].slice.call(document.querySelectorAll('#ft-cart-checkout-btn, .ft-pdp-form button[type="submit"]')) : [];
  var kontaktUnten = 0;

  function sichtbar(r) { return !(r.width <= 0 && r.height <= 0); }
  /* Cookie-Hinweis von Shopify (12.10.2026): section#shopify-pc__banner direkt unter body, kommt erst nach dem Laden und
     liegt unten über den Knöpfen. Solange er offen ist, sind die Knöpfe weg; nach der Wahl setzt Shopify display: none. */
  function shopifyHinweisOffen() {
    var b = document.getElementById('shopify-pc__banner');
    return !!b && b.getBoundingClientRect().height > 0 && window.getComputedStyle(b).display !== 'none';
  }
  function leisteHoehe(vh) {
    var h = 0;
    leistenUnten.forEach(function (l) {
      var cs = window.getComputedStyle(l);
      var r = l.getBoundingClientRect();
      if (cs.display === 'none' || cs.visibility === 'hidden' || r.height <= 0 || r.top >= vh - 1) return;
      /* 12.10.2026 abends (live gemessen): Die Kaufleiste der Produktseite fährt mit transform ein. Mitten in der Fahrt gemessen
         saßen die Knöpfe 4 px auf ihrer Oberkante. Mit is-visible zählt darum die Endlage: Abstand unten plus volle Höhe. */
      if (l.classList.contains('is-visible')) h = Math.max(h, Math.round((parseFloat(cs.bottom) || 0) + l.offsetHeight));
      else h = Math.max(h, Math.round(vh - r.top));
    });
    return h;
  }
  /* Ein- und Ausfahren der Kaufleisten auch ohne Scrollen mitbekommen */
  if (kontakt && window.MutationObserver) {
    leistenUnten.forEach(function (l) {
      new MutationObserver(function () { setzeKontakt(); }).observe(l, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    });
  }
  /* 12.10.2026 abends (Pascal: „der chat button verschwindet bei mir am desktop“): Am PC (ab 990 px) bleibt der Knopf beim
     Runterscrollen stehen, und die Fußzeile blendet ihn nur aus, solange sie hinter ihm liegt (wie .ft-dock-frei). Handy unverändert. */
  /* 12.10.2026 spät (Pascal: „der ist kurz da mit den anderen buttons und dann verschwinden alle 3 nach unten, obwohl ich nur den
     live chat button sehen und beibehalten will auf dem desktop“; sein Fenster war schmaler als 990 px): PC heißt Rechner mit Maus,
     egal wie breit, oder ab 990 px. Gleiche Abfrage wie in sections/ft-footer.liquid. Am PC ist der Knopf nur weg, solange der
     Cookie-Hinweis offen ist (setzeKontakt); Scrollen, Fußzeile und Rechtshinweise blenden ihn dort nicht mehr aus. */
  var pcMq = window.matchMedia ? window.matchMedia('(min-width: 990px), (hover: hover) and (pointer: fine)') : null;
  function istPc() { return !!(pcMq && pcMq.matches); }
  function zoneImBild() {
    var vh = window.innerHeight || root.clientHeight;
    var i, r;
    var pc = istPc();
    if (shopifyHinweisOffen()) return true;
    for (i = 0; i < zonenGanz.length; i++) {
      if (pc && zonenGanz[i].tagName === 'FOOTER') continue;
      r = zonenGanz[i].getBoundingClientRect();
      if (sichtbar(r) && r.bottom > 0 && r.top < vh - 24) return true;
    }
    var bereich = kMenue ? KNOPF_BEREICH : (kontakt.offsetHeight + 40);
    var unten = vh - kontaktUnten;
    /* 14.10.2026: .ft-dock-frei bei jedem Aufruf neu suchen. Die Passungs-Kästen der Karten (snippets/ft-karten-passung) kommen erst nach dem Laden
       dazu und sollen wie die Rechtshinweise nie hinter den Knöpfen liegen (Rechtsabteilung: „laut Fahrzeugdaten“ immer sichtbar). */
    var zonen = [].slice.call(document.querySelectorAll('.ft-dock-frei')).concat(schutzKnoepfe);
    if (pc) zonen = zonen.concat(zonenGanz.filter(function (z) { return z.tagName === 'FOOTER'; }));
    for (i = 0; i < zonen.length; i++) {
      if (leistenUnten.some(function (l) { return l.contains(zonen[i]); })) continue;
      r = zonen[i].getBoundingClientRect();
      if (sichtbar(r) && r.top < unten && r.bottom > unten - bereich) return true;
    }
    return false;
  }

  function menue(auf) {
    if (!kontakt || !kMenue || !kKnopf) return;
    kMenue.hidden = !auf;
    kontakt.classList.toggle('is-offen', auf);
    kKnopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
  }

  function setzeKontakt() {
    if (!kontakt) return;
    var vh = window.innerHeight || root.clientHeight;
    var h = leisteHoehe(vh);
    if (h !== kontaktUnten) { kontaktUnten = h; kontakt.style.setProperty('--ft-sk-unten', h + 'px'); }
    var weg = istPc() ? shopifyHinweisOffen() : (kontaktWegScroll || zoneImBild());
    if (weg && kontakt.classList.contains('is-offen')) menue(false);
    kontakt.classList.toggle('is-weg', weg);
  }

  /* Erscheinen und Schließen des Shopify-Hinweises ohne Scrollen mitbekommen: body-Kinder beobachten, bis er da ist,
     dann sein style-Attribut. */
  if (kontakt && window.MutationObserver && document.body) {
    var hinweisBeob = null;
    var hinweisSuchen = function () {
      var b = document.getElementById('shopify-pc__banner');
      if (b && !hinweisBeob) {
        hinweisBeob = new MutationObserver(setzeKontakt);
        hinweisBeob.observe(b, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
      }
      setzeKontakt();
    };
    new MutationObserver(hinweisSuchen).observe(document.body, { childList: true });
    hinweisSuchen();
  }

  if (kontakt && kKnopf && kMenue) {
    kKnopf.addEventListener('click', function (e) {
      e.stopPropagation();
      menue(kMenue.hidden);
    });
    document.addEventListener('click', function (e) {
      if (!kontakt.contains(e.target)) menue(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !kMenue.hidden) { menue(false); kKnopf.focus(); }
    });
  }

  /* ── 3) Chip-Leisten (Phase 4): Verlauf rechts, solange es weitergeht;
        der aktive Chip steht beim Laden im Bild ─────────────────────────── */
  var leisten = [].slice.call(document.querySelectorAll('.ft-chipleiste, .ft-fpb-tabs'));
  function mehr(l) {
    l.classList.toggle('is-mehr', l.scrollWidth - l.clientWidth - l.scrollLeft > 4);
  }
  leisten.forEach(function (l) {
    var aktiv = l.querySelector('.is-on');
    if (aktiv && l.scrollWidth > l.clientWidth) {
      var innen = parseFloat(getComputedStyle(l).paddingLeft) || 0;
      l.scrollLeft += aktiv.getBoundingClientRect().left - l.getBoundingClientRect().left - innen;
    }
    mehr(l);
    l.addEventListener('scroll', function () { mehr(l); }, { passive: true });
  });

  /* ── 4) Werkzeugleiste (Phase 4): Linie darunter, solange sie klebt ──── */
  var wlLeisten = [].slice.call(document.querySelectorAll('.ft-wl-leiste'));
  function klebt() {
    for (var i = 0; i < wlLeisten.length; i++) {
      var w = wlLeisten[i];
      var cs = getComputedStyle(w);
      var an = cs.position === 'sticky' && (window.scrollY || 0) > 0 &&
        Math.abs(w.getBoundingClientRect().top - (parseFloat(cs.top) || 0)) <= 1;
      w.classList.toggle('is-klebt', an);
    }
  }

  /* ── Scrollen ─────────────────────────────────────────────────────────── */
  var letzteY = window.scrollY || root.scrollTop || 0;
  function scrollen() {
    var y = window.scrollY || root.scrollTop || 0;
    var d = y - letzteY;
    if (Math.abs(d) >= SCHWELLE) {
      var oben = y < 80;
      /* Kopf: oben immer da; runter weg; hoch da; nie weg bei offenem Menü */
      /* 02.10.2026 abends (Pascal: „gefällt mir nicht, dass die Navbar sich einklappt“): Kopfzeile mit Menü bleibt beim Scrollen
         immer stehen, nur die schwarze Leiste darüber scrollt weg (CSS). Vorher: runter weg, hoch da (LAYOUT-FIXES Phase 2). */
      if (sek) setzeKopf(false);
      kontaktWegScroll = !oben && d > 0;
      letzteY = y;
    }
    setzeKontakt();
    klebt();
  }
  function allesMessen() { messen(); setzeKontakt(); klebt(); leisten.forEach(mehr); }
  window.addEventListener('scroll', scrollen, { passive: true });
  window.addEventListener('resize', allesMessen);
  window.addEventListener('load', allesMessen);
  window.addEventListener('pageshow', allesMessen);
  messen();
  setzeKontakt();
  klebt();
})();
